import { __extends } from "tslib";
import { BaseAdapter } from '../core';
import { ICON_CONSTANTS } from './icon-constants';
var IconAdapter = /** @class */ (function (_super) {
    __extends(IconAdapter, _super);
    function IconAdapter(component) {
        return _super.call(this, component) || this;
    }
    IconAdapter.prototype.initialize = function () {
        if (!this._component.hasAttribute('aria-hidden')) {
            this._component.setAttribute('aria-hidden', 'true');
        }
    };
    IconAdapter.prototype.canLazyLoad = function () {
        return !!window.IntersectionObserver;
    };
    IconAdapter.prototype.observeVisibility = function (listener) {
        var _this = this;
        this._observer = new IntersectionObserver(function (entries) {
            if (entries.some(function (entry) { return entry.isIntersecting; })) {
                _this.destroyVisibilityObserver();
                listener();
            }
        }, { rootMargin: ICON_CONSTANTS.numbers.LAZY_ROOT_MARGIN + "px" });
        this._observer.observe(this._component);
    };
    IconAdapter.prototype.destroyVisibilityObserver = function () {
        if (this._observer) {
            this._observer.disconnect();
            this._observer = undefined;
        }
    };
    IconAdapter.prototype.setContent = function (content) {
        var styleTag = this._component.shadowRoot.querySelector('style');
        this._component.shadowRoot.innerHTML = content;
        if (styleTag) {
            this._component.shadowRoot.appendChild(styleTag);
        }
    };
    return IconAdapter;
}(BaseAdapter));
export { IconAdapter };
